var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6972 14.2384L12.6976 14.2389C11.3593 15.3408 9.6592 16.0002 7.80852 16.0002C4.83446 16.0002 2.24874 14.2973 0.929688 11.7914L3.4605 9.66919C4.12001 11.4723 5.81794 12.7558 7.80852 12.7558C8.66413 12.7558 9.4657 12.5189 10.1535 12.1052L12.6972 14.2384Z",
    fill: "#28B446"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6183 8.00012C15.6183 7.48934 15.5716 6.98955 15.4819 6.50562H7.98047V9.67047H12.1564C11.7805 10.6982 11.0669 11.5566 10.1538 12.1052L12.6975 14.2384L12.6979 14.2388C14.074 13.1056 15.0674 11.5043 15.4476 9.67047C15.5595 9.13156 15.6183 8.57287 15.6183 8.00012Z",
    fill: "#518EF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7942 1.84176L10.2642 3.96351C9.55238 3.5077 8.7109 3.24438 7.80939 3.24438C5.77375 3.24438 4.04406 4.58679 3.41759 6.45452L0.873474 4.32089H0.873047C2.17279 1.75385 4.79112 0 7.80939 0C9.70427 0 11.4417 0.691439 12.7942 1.84176Z",
    fill: "#F14336"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.873206 4.3208C0.314946 5.42234 0 6.67334 0 7.99994C0 9.37182 0.336848 10.6628 0.930709 11.7911L3.46151 9.669C3.27099 9.14991 3.16717 8.58719 3.16711 7.99994C3.16711 7.45884 3.25551 6.93884 3.41771 6.45443L0.873629 4.32081L0.873206 4.3208C0.873208 4.3208 0.873205 4.3208 0.873206 4.3208Z",
    fill: "#FBBB00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.33ff4b500a276e7d232e3c5717e5630d.svg";
export { ForwardRef as ReactComponent };